import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import AIAgents from "./pages/AIAgents";
import About from "./pages/About";
import Partners from "./pages/Partners";
import Blog from "./pages/Blog";
import Cases from "./pages/Cases";
import Industry from "./pages/Industry";
import Demo from "./pages/Demo";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/ai-agents" element={<AIAgents />} />
            <Route path="/about" element={<About />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/industries/:industry" element={<Industry />} />
            <Route path="/login" element={<Contact />} />
            <Route path="/community" element={<Blog />} />
            <Route path="/help" element={<Contact />} />
            <Route path="/privacy" element={<Contact />} />
            <Route path="/terms" element={<Contact />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Toaster />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
